import { render, staticRenderFns } from "./Values.vue?vue&type=template&id=79ae7318&scoped=true&"
import script from "./Values.vue?vue&type=script&lang=js&"
export * from "./Values.vue?vue&type=script&lang=js&"
import style0 from "./Values.scss?vue&type=style&index=0&id=79ae7318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ae7318",
  null
  
)

export default component.exports